import { put, takeLatest, select, all } from 'redux-saga/effects';
import { getSelectedRefundFamilyIds } from '../passengers/selectors';
import { getSelectedReason } from '../selectedReason/selectors';
import { SET_SELECTED_REASON } from '../selectedReason/actions';
import { setDocuments } from './actions';
import { ReasonCategory, RefundDocumentsState, RefundSelectedReasonState } from '../types';

function* setInitialDocuments() {
	const [selectedPassengersIds, selectedReason]: [string[], RefundSelectedReasonState] = yield all([
		select(getSelectedRefundFamilyIds),
		select(getSelectedReason)
	]);

	if (
		!selectedReason ||
		!selectedReason.docs?.length ||
		!selectedPassengersIds.length ||
		selectedReason?.category === ReasonCategory.Voluntary
	) {
		yield put(setDocuments({}));

		return;
	}

	const documents: RefundDocumentsState = {};

	/** Сетаем пустые документы для каждого пассажира при выборе причины возврата */
	selectedPassengersIds.forEach(passengerId => {
		documents[passengerId] = [];
	});

	yield put(setDocuments(documents));

	return;
}

/** После выбора причины возврата, инициализируем документы */
export function* documentsSagas() {
	yield takeLatest(SET_SELECTED_REASON, setInitialDocuments);
}
